export default __webpack_public_path__ + "media/images/partners/Geothink_Logo_NT-6d70cbf2336c48b463096e11ddba58c2.png";